import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { FuleTypeService } from '../g-settings/fule-type.service';
import { ItemTypeService } from '../g-settings/item-type.service';
import { BrandService } from '../g-settings/brand.service';
import { ManufacturerService } from '../g-settings/manufacturer.service';
import { ModelService } from '../g-settings/model.service';
import { SsCategoryService } from '../g-settings/ss-category.service';
import { StatusTypeService } from '../g-settings/status-type.service';
import { TagsTypeService } from '../g-settings/tags-type.service';
import { TagsService } from '../g-settings/tags.service';
import { AuthenticationService } from '../../auth/authentication.service';
import { LocalStorageService } from '../../common/local-storage.service';
import { CookieService } from '../../common/cookie.service';
import { CustomerService } from '../g-customer/customer.service';
import { VehicleService } from '../g-vehicle/vehicle.service';
import { AccountsService } from '../fleet-desk/accounts.service';
import { SupplierService } from '../g-supplier/supplier.service';
import { ItemService } from '../g-settings/item.service';
import { PackageService } from '../g-packages/package.service';
import { PackageTypeService } from '../g-packages/package-type.service';
import { LoggerSrvice } from '../../common/logger.service';
import { PurchaseOrderService } from '../g-purchase/purchase-order.service';
import { PurchaseRequsitionService } from '../g-purchase/purchase-requsition.service';
import { DefaultService } from '../../common/default.service';
import { NgxBootstrapModalExt } from '../../common/ngx-bsmodal';
import { UnitsService } from '../g-settings/units.service';
import { ColoursService } from '../g-settings/colours.service';
import { CountryService } from '../g-settings/country.service';
import { PurchaseService } from '../g-purchase/purchase.service';
import { ComplainAndSuggestionsService } from '../g-settings/complain-and-suggestions.service';
import { SaleService } from '../g-sale/sale.service';
import { PhoneCodeServiceService } from '../g-settings/phone-code-service.service';
import { SettingService } from '../g-settings/setting.service';
import { ReportingServiceService } from '../reporting/reporting-service.service';
import { WareHouseService } from '../g-settings/warehouse.service';
import { WarehouseItemsService } from '../g-settings/warehouse-items.service';
import { DataServiceService } from '../../common/data-service.service';
import { SalesReportServiceService } from '../reporting/sales-report-service.service';
import { GQuotationService } from '../g-quotation/g-quotation.service';
import { GVehicleStatusService } from '../g-settings/g-vehicle-status.service';
import { VehicleNotifyService } from '../g-vehicle/vehiclesnotify.service';
import { GDashboardService } from '../gdashboard.service';
import { GsettingService } from '../gsetting.service';
import { GPurchaseService } from '../gpurchase.service';
import { GSaleService } from '../gsale.service';
import { GReportingService } from '../greporting.service';
let UnitOfWorkService = class UnitOfWorkService {
    constructor(
    // fleet-desk services
    accountsService, 
    // G customer
    customerService, 
    // G Supplier
    supplierService, 
    // G Vehicle
    vehicleService, vehicleNotifyService, gVehicleStatusService, 
    // package
    packageService, packageTypeService, 
    // purchase
    purchaseService, purchaseOrderService, purchaseRequisitionService, 
    // Sales
    saleService, 
    // Gsettings
    brandService, fuleTypeService, itemService, itemTypeService, manufacturerService, modelService, ssCategoryService, statusTypeService, tagsTypeService, tagsService, unitService, colourService, countryService, complainsAndSuggestionsService, phoneCodeService, settingservice, reportingservice, salesreportservice, warehouseService, wareHouseItemService, 
    // Auth
    authenticationService, 
    // local storage and cookies
    localService, cookieService, defaultService, 
    // logger
    logger, 
    // bs modal service
    modalServiceEx, 
    ////Data Service/////////////////////
    dataService, quotationService, 
    /// Latest Garage
    gDashboardService, gSettingService, gPurchaseService, gSaleService, gReportingService) {
        this.accountsService = accountsService;
        this.customerService = customerService;
        this.supplierService = supplierService;
        this.vehicleService = vehicleService;
        this.vehicleNotifyService = vehicleNotifyService;
        this.gVehicleStatusService = gVehicleStatusService;
        this.packageService = packageService;
        this.packageTypeService = packageTypeService;
        this.purchaseService = purchaseService;
        this.purchaseOrderService = purchaseOrderService;
        this.purchaseRequisitionService = purchaseRequisitionService;
        this.saleService = saleService;
        this.brandService = brandService;
        this.fuleTypeService = fuleTypeService;
        this.itemService = itemService;
        this.itemTypeService = itemTypeService;
        this.manufacturerService = manufacturerService;
        this.modelService = modelService;
        this.ssCategoryService = ssCategoryService;
        this.statusTypeService = statusTypeService;
        this.tagsTypeService = tagsTypeService;
        this.tagsService = tagsService;
        this.unitService = unitService;
        this.colourService = colourService;
        this.countryService = countryService;
        this.complainsAndSuggestionsService = complainsAndSuggestionsService;
        this.phoneCodeService = phoneCodeService;
        this.settingservice = settingservice;
        this.reportingservice = reportingservice;
        this.salesreportservice = salesreportservice;
        this.warehouseService = warehouseService;
        this.wareHouseItemService = wareHouseItemService;
        this.authenticationService = authenticationService;
        this.localService = localService;
        this.cookieService = cookieService;
        this.defaultService = defaultService;
        this.logger = logger;
        this.modalServiceEx = modalServiceEx;
        this.dataService = dataService;
        this.quotationService = quotationService;
        this.gDashboardService = gDashboardService;
        this.gSettingService = gSettingService;
        this.gPurchaseService = gPurchaseService;
        this.gSaleService = gSaleService;
        this.gReportingService = gReportingService;
    }
};
UnitOfWorkService.ctorParameters = () => [
    { type: AccountsService },
    { type: CustomerService },
    { type: SupplierService },
    { type: VehicleService },
    { type: VehicleNotifyService },
    { type: GVehicleStatusService },
    { type: PackageService },
    { type: PackageTypeService },
    { type: PurchaseService },
    { type: PurchaseOrderService },
    { type: PurchaseRequsitionService },
    { type: SaleService },
    { type: BrandService },
    { type: FuleTypeService },
    { type: ItemService },
    { type: ItemTypeService },
    { type: ManufacturerService },
    { type: ModelService },
    { type: SsCategoryService },
    { type: StatusTypeService },
    { type: TagsTypeService },
    { type: TagsService },
    { type: UnitsService },
    { type: ColoursService },
    { type: CountryService },
    { type: ComplainAndSuggestionsService },
    { type: PhoneCodeServiceService },
    { type: SettingService },
    { type: ReportingServiceService },
    { type: SalesReportServiceService },
    { type: WareHouseService },
    { type: WarehouseItemsService },
    { type: AuthenticationService },
    { type: LocalStorageService },
    { type: CookieService },
    { type: DefaultService },
    { type: LoggerSrvice },
    { type: NgxBootstrapModalExt },
    { type: DataServiceService },
    { type: GQuotationService },
    { type: GDashboardService },
    { type: GsettingService },
    { type: GPurchaseService },
    { type: GSaleService },
    { type: GReportingService }
];
UnitOfWorkService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], UnitOfWorkService);
export { UnitOfWorkService };
//# sourceMappingURL=unit-of-work.service.js.map